import Services from './base-services'

const service = new Services()

export default {
    getInfoByToken: () => {
        return service.post('token')
    },
}
